import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ability from '@/libs/acl/ability'

export default function useServiceCodesList() {

    //User toast
    const toast = useToast()

    const refServiceCodeListTable = ref(null)

    const tableColumns = [
        {key: 'service_code', label: '項目類型代號',sortable: true},
        {key: 'name', label: '項目類型'},
        {key: 'description', label: '描述'},
        {key: 'is_active', label: '狀態'},
        {key: 'action', label: '操作'}
    ]

    const perPage = ref(10)
    const totalServiceCodes = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const dataMeta = computed(() => {
        const localItemsCount = refServiceCodeListTable.value ? refServiceCodeListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalServiceCodes.value,
        }
    })

    const refetchData = () => {
        refServiceCodeListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchServiceCodes = (ctx, callback) => {
        store.dispatch('setting-servicecode/fetchServiceCodes',{
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response =>{
            const {service_codes, total} = response.data
            callback(service_codes)
            totalServiceCodes.value = total
        
        })
        .catch((error) => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching service codes list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger'
                }
            })
        })
    }

    return {
        fetchServiceCodes,
        tableColumns,
        perPage,
        currentPage,
        totalServiceCodes,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refServiceCodeListTable,
        ability,
        refetchData
    }

}